import { render, staticRenderFns } from "./ItemCategories.vue?vue&type=template&id=6aa2f2f4&scoped=true&"
import script from "./ItemCategories.vue?vue&type=script&lang=js&"
export * from "./ItemCategories.vue?vue&type=script&lang=js&"
import style0 from "./ItemCategories.vue?vue&type=style&index=0&id=6aa2f2f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa2f2f4",
  null
  
)

export default component.exports